var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var Glyphicon = require("components/utility/icons/Glyphicon");
import ReactSelect from "react-select";

import { Link } from "react-router-dom";


class CleverSyncDistrictData extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {loading: false } // SELECT SCHOOL ORG WITH SCHOOL WITH CANONICAL ID
	}

	render() {

		if (this.state.loading) {
			var view = <Spinner placeholder={ true } scale={ 1.7 } />
		} else {
			var view = (<button className="btn btn-primary sync-action" onClick={this.syncDistrict}>Sync district with Clever</button>)
		}

		if (this.props.accessToken.synced_at != null) {
			var lastSync = (
				<div>
					Last sync: <b>{ this.props.accessToken.synced_at }</b>
				</div>
			)
		} 
		return (
			<div className="CleverSyncDistrictData">
				{ lastSync }
				{ view }
				This process may take few minutes.
			</div>
		);
	}

	syncDistrict() {
		this.setState({loading: true})
		var accessTokenID = this.props.accessToken.id;
		var newToken = {clever_access_token: {synced_at: new Date}}
		CurrentUser.api().patchCleverAccessToken(accessTokenID, newToken, $wr.apiHandler((response) => {
			this.props.onAccessTokenSync( response.clever_access_token );
			this.setState({loading: false})
		}));
	}
};

CleverSyncDistrictData.propTypes = PageStrictPropTypes({
});

module.exports = CleverSyncDistrictData;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/CleverSyncDistrictData.js